export default __webpack_public_path__ + "static/media/doller.2f403f39.svg";